'use strict';

var _from = require('babel-runtime/core-js/array/from');

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var activityPage = document.querySelector('.page-node-type-activity');

var resizeMainContainerOnChange = function resizeMainContainerOnChange(contentEntriesContainer, contents, entryIndex) {
  contentEntriesContainer.style.height = contents[entryIndex].offsetHeight + 30 + 'px';
};

var handleMenuEntryClicked = function handleMenuEntryClicked() {
  var entries = activityPage.querySelectorAll('.head .entries li');
  var contentEntriesContainer = activityPage.querySelector('.content .entries');

  if (!contentEntriesContainer) {
    return;
  }

  var contents = contentEntriesContainer.querySelectorAll('.entry');
  resizeMainContainerOnChange(contentEntriesContainer, contents, 0);
  entries.forEach(function (entry) {
    entry.addEventListener('click', function () {
      var index = (0, _from2.default)(entry.parentNode.children).indexOf(entry);
      entries.forEach(function (entry) {
        return entry.classList.remove('current');
      });
      contents.forEach(function (content) {
        return content.classList.remove('current');
      });
      entry.classList.add('current');
      contents[index].classList.add('current');
      resizeMainContainerOnChange(contentEntriesContainer, contents, index);
    });
  });
};

activityPage && handleMenuEntryClicked();


//////////////////
// WEBPACK FOOTER
// ./js/slideshow/activity-entries.js
// module id = ./js/slideshow/activity-entries.js
// module chunks = 0